{
  "k8s.cluster-role": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "number",
        "field": "length(rules || `[]`)",
        "headerName": "Rules"
      },
      {
        "type": "boolean",
        "field": "contains(rules[].verbs[] || `[]`, '*')",
        "headerName": "Wildcard Verbs"
      },
      {
        "type": "boolean",
        "field": "contains(rules[].resources[] || `[]`, '*')",
        "headerName": "Wildcard Resources"
      },
      {
        "type": "boolean",
        "field": "aggregation_rule != null",
        "headerName": "Aggregated"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      },
      {
        "type": "string",
        "field": "metadata.labels.\"kubernetes.io/bootstrapping\"",
        "headerName": "Bootstrapping",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.config-map": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "array",
        "field": "keys(data || `{}`)",
        "headerName": "Keys"
      },
      {
        "type": "boolean",
        "field": "immutable",
        "headerName": "Immutable"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.custom-resource": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "string",
        "field": "kind",
        "headerName": "Kind"
      },
      {
        "type": "string",
        "field": "crd_group",
        "headerName": "Group"
      },
      {
        "type": "time",
        "field": "metadata.creationTimestamp",
        "headerName": "Created"
      },
      {
        "type": "string",
        "field": "crd_version",
        "headerName": "Version",
        "hidden": true
      },
      {
        "type": "string",
        "field": "crd_scope",
        "headerName": "Scope",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.daemon-set": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "number",
        "field": "status.desired_number_scheduled",
        "headerName": "Desired"
      },
      {
        "type": "number",
        "field": "status.number_ready",
        "headerName": "Ready"
      },
      {
        "type": "number",
        "field": "status.number_available",
        "headerName": "Available"
      },
      {
        "type": "array",
        "field": "spec.template.spec.containers[].image",
        "headerName": "Images"
      },
      {
        "type": "string",
        "field": "spec.update_strategy.type",
        "headerName": "Update Strategy"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      },
      {
        "type": "number",
        "field": "status.number_unavailable",
        "headerName": "Unavailable",
        "hidden": true
      },
      {
        "type": "number",
        "field": "status.number_misscheduled",
        "headerName": "Misscheduled",
        "hidden": true
      },
      {
        "type": "boolean",
        "field": "spec.template.spec.host_network",
        "headerName": "Host Network",
        "hidden": true
      },
      {
        "type": "string",
        "field": "spec.template.spec.service_account_name",
        "headerName": "Service Account",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.deployment": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "number",
        "field": "spec.replicas",
        "headerName": "Desired"
      },
      {
        "type": "number",
        "field": "status.ready_replicas",
        "headerName": "Ready"
      },
      {
        "type": "number",
        "field": "status.available_replicas",
        "headerName": "Available"
      },
      {
        "type": "array",
        "field": "spec.template.spec.containers[].image",
        "headerName": "Images"
      },
      {
        "type": "string",
        "field": "spec.strategy.type",
        "headerName": "Strategy"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      },
      {
        "type": "number",
        "field": "status.updated_replicas",
        "headerName": "Up to Date",
        "hidden": true
      },
      {
        "type": "number",
        "field": "status.unavailable_replicas",
        "headerName": "Unavailable",
        "hidden": true
      },
      {
        "type": "boolean",
        "field": "spec.paused",
        "headerName": "Paused",
        "hidden": true
      },
      {
        "type": "string",
        "field": "spec.template.spec.service_account_name",
        "headerName": "Service Account",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.namespace": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "status.phase",
        "headerName": "Phase"
      },
      {
        "type": "string",
        "field": "metadata.labels.\"pod-security.kubernetes.io/enforce\"",
        "headerName": "PSA Enforce"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      },
      {
        "type": "string",
        "field": "metadata.labels.\"pod-security.kubernetes.io/warn\"",
        "headerName": "PSA Warn",
        "hidden": true
      },
      {
        "type": "string",
        "field": "metadata.labels.\"pod-security.kubernetes.io/audit\"",
        "headerName": "PSA Audit",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.node": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "status.conditions[?type=='Ready'].status | [0]",
        "headerName": "Ready"
      },
      {
        "type": "string",
        "field": "status.node_info.kubelet_version",
        "headerName": "Kubelet Version"
      },
      {
        "type": "string",
        "field": "status.addresses[?type=='InternalIP'].address | [0]",
        "headerName": "Internal IP"
      },
      {
        "type": "string",
        "field": "metadata.labels.\"node.kubernetes.io/instance-type\"",
        "headerName": "Instance Type"
      },
      {
        "type": "string",
        "field": "metadata.labels.\"topology.kubernetes.io/zone\"",
        "headerName": "Zone"
      },
      {
        "type": "boolean",
        "field": "spec.unschedulable",
        "headerName": "Unschedulable"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      },
      {
        "type": "string",
        "field": "status.node_info.os_image",
        "headerName": "OS Image",
        "hidden": true
      },
      {
        "type": "string",
        "field": "status.node_info.architecture",
        "headerName": "Architecture",
        "hidden": true
      },
      {
        "type": "string",
        "field": "status.node_info.container_runtime_version",
        "headerName": "Container Runtime",
        "hidden": true
      },
      {
        "type": "string",
        "field": "status.capacity.cpu",
        "headerName": "CPU",
        "hidden": true
      },
      {
        "type": "string",
        "field": "status.capacity.memory",
        "headerName": "Memory",
        "hidden": true
      },
      {
        "type": "array",
        "field": "spec.taints[].join('=', [key, effect])",
        "headerName": "Taints",
        "hidden": true
      },
      {
        "type": "string",
        "field": "spec.provider_id",
        "headerName": "Provider ID",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.pod": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "string",
        "field": "status.phase",
        "headerName": "Phase"
      },
      {
        "type": "string",
        "field": "spec.node_name",
        "headerName": "Node"
      },
      {
        "type": "array",
        "field": "spec.containers[].image",
        "headerName": "Images"
      },
      {
        "type": "number",
        "field": "sum(status.container_statuses[].restart_count || `[]`)",
        "headerName": "Restarts"
      },
      {
        "type": "string",
        "field": "status.pod_ip",
        "headerName": "Pod IP"
      },
      {
        "type": "string",
        "field": "spec.service_account_name",
        "headerName": "Service Account"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      },
      {
        "type": "string",
        "field": "status.qos_class",
        "headerName": "QoS Class",
        "hidden": true
      },
      {
        "type": "array",
        "field": "spec.containers[?security_context.privileged].name",
        "headerName": "Privileged Containers",
        "hidden": true
      },
      {
        "type": "boolean",
        "field": "spec.host_network",
        "headerName": "Host Network",
        "hidden": true
      },
      {
        "type": "boolean",
        "field": "spec.host_pid",
        "headerName": "Host PID",
        "hidden": true
      },
      {
        "type": "string",
        "field": "spec.priority_class_name",
        "headerName": "Priority Class",
        "hidden": true
      },
      {
        "type": "string",
        "field": "metadata.owner_references[0].kind",
        "headerName": "Owner Kind",
        "hidden": true
      },
      {
        "type": "string",
        "field": "metadata.owner_references[0].name",
        "headerName": "Owner",
        "hidden": true
      },
      {
        "type": "string",
        "field": "status.host_ip",
        "headerName": "Host IP",
        "hidden": true
      },
      {
        "type": "time",
        "field": "status.start_time",
        "headerName": "Started",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.replica-set": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "number",
        "field": "spec.replicas",
        "headerName": "Desired"
      },
      {
        "type": "number",
        "field": "status.ready_replicas",
        "headerName": "Ready"
      },
      {
        "type": "number",
        "field": "status.available_replicas",
        "headerName": "Available"
      },
      {
        "type": "string",
        "field": "metadata.owner_references[0].name",
        "headerName": "Owner"
      },
      {
        "type": "array",
        "field": "spec.template.spec.containers[].image",
        "headerName": "Images"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.replication-controller": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "number",
        "field": "spec.replicas",
        "headerName": "Desired"
      },
      {
        "type": "number",
        "field": "status.ready_replicas",
        "headerName": "Ready"
      },
      {
        "type": "number",
        "field": "status.available_replicas",
        "headerName": "Available"
      },
      {
        "type": "array",
        "field": "spec.template.spec.containers[].image",
        "headerName": "Images"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.role": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "number",
        "field": "length(rules || `[]`)",
        "headerName": "Rules"
      },
      {
        "type": "boolean",
        "field": "contains(rules[].verbs[] || `[]`, '*')",
        "headerName": "Wildcard Verbs"
      },
      {
        "type": "boolean",
        "field": "contains(rules[].resources[] || `[]`, '*')",
        "headerName": "Wildcard Resources"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.secret": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "string",
        "field": "type",
        "headerName": "Type"
      },
      {
        "type": "boolean",
        "field": "immutable",
        "headerName": "Immutable"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.service": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "string",
        "field": "spec.type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "spec.cluster_ip",
        "headerName": "Cluster IP"
      },
      {
        "type": "array",
        "field": "status.load_balancer.ingress[].[ip, hostname][][]",
        "headerName": "Load Balancer"
      },
      {
        "type": "array",
        "field": "spec.ports[].join('/', [to_string(port), protocol])",
        "headerName": "Ports"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      },
      {
        "type": "array",
        "field": "spec.external_ips",
        "headerName": "External IPs",
        "hidden": true
      },
      {
        "type": "array",
        "field": "spec.load_balancer_source_ranges",
        "headerName": "LB Source Ranges",
        "hidden": true
      },
      {
        "type": "string",
        "field": "spec.external_traffic_policy",
        "headerName": "External Traffic Policy",
        "hidden": true
      },
      {
        "type": "string",
        "field": "spec.session_affinity",
        "headerName": "Session Affinity",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.service-account": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "boolean",
        "field": "automount_service_account_token",
        "headerName": "Automount Token"
      },
      {
        "type": "array",
        "field": "image_pull_secrets[].name",
        "headerName": "Image Pull Secrets"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      },
      {
        "type": "array",
        "field": "secrets[].name",
        "headerName": "Secrets",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.stateful-set": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "number",
        "field": "spec.replicas",
        "headerName": "Desired"
      },
      {
        "type": "number",
        "field": "status.ready_replicas",
        "headerName": "Ready"
      },
      {
        "type": "string",
        "field": "spec.service_name",
        "headerName": "Service"
      },
      {
        "type": "array",
        "field": "spec.template.spec.containers[].image",
        "headerName": "Images"
      },
      {
        "type": "string",
        "field": "spec.update_strategy.type",
        "headerName": "Update Strategy"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      },
      {
        "type": "string",
        "field": "spec.pod_management_policy",
        "headerName": "Pod Management",
        "hidden": true
      },
      {
        "type": "string",
        "field": "status.current_revision",
        "headerName": "Current Revision",
        "hidden": true
      },
      {
        "type": "string",
        "field": "status.update_revision",
        "headerName": "Update Revision",
        "hidden": true
      },
      {
        "type": "string",
        "field": "spec.template.spec.service_account_name",
        "headerName": "Service Account",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.volume": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "spec.capacity.storage",
        "headerName": "Capacity"
      },
      {
        "type": "array",
        "field": "spec.access_modes",
        "headerName": "Access Modes"
      },
      {
        "type": "string",
        "field": "spec.persistent_volume_reclaim_policy",
        "headerName": "Reclaim Policy"
      },
      {
        "type": "string",
        "field": "status.phase",
        "headerName": "Phase"
      },
      {
        "type": "string",
        "field": "spec.storage_class_name",
        "headerName": "Storage Class"
      },
      {
        "type": "string",
        "field": "spec.claim_ref.namespace",
        "headerName": "Claim Namespace"
      },
      {
        "type": "string",
        "field": "spec.claim_ref.name",
        "headerName": "Claim"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      },
      {
        "type": "string",
        "field": "spec.csi.driver",
        "headerName": "CSI Driver",
        "hidden": true
      },
      {
        "type": "string",
        "field": "spec.csi.volume_handle",
        "headerName": "Volume Handle",
        "hidden": true
      },
      {
        "type": "string",
        "field": "spec.volume_mode",
        "headerName": "Volume Mode",
        "hidden": true
      }
    ],
    "id": "metadata.uid"
  },
  "k8s.volume-claim": {
    "columns": [
      {
        "type": "string",
        "field": "metadata.name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "metadata.namespace",
        "headerName": "Namespace"
      },
      {
        "type": "string",
        "field": "status.phase",
        "headerName": "Phase"
      },
      {
        "type": "string",
        "field": "spec.resources.requests.storage",
        "headerName": "Requested"
      },
      {
        "type": "string",
        "field": "status.capacity.storage",
        "headerName": "Capacity"
      },
      {
        "type": "array",
        "field": "spec.access_modes",
        "headerName": "Access Modes"
      },
      {
        "type": "string",
        "field": "spec.storage_class_name",
        "headerName": "Storage Class"
      },
      {
        "type": "string",
        "field": "spec.volume_name",
        "headerName": "Volume"
      },
      {
        "type": "time",
        "field": "metadata.creation_timestamp",
        "headerName": "Created"
      }
    ],
    "id": "metadata.uid"
  }
}
